import { makeStyles, tokens } from '@fluentui/react-components';

export const useDailyHabitsSpotlightStyles = makeStyles({
  icon: {
    '& > svg': {
      width: tokens.fontSizeBase500,
      height: tokens.fontSizeBase500,
    },
  },
});
